import styled from 'styled-components';

export const BadgesList = styled.div`
    font-family: Inter, sans-serif;
    font-size: 13px;
    letter-spacing: 0.05em;
    font-weight: 500;
`;

export const ListMap = styled.div`
    display: flex;
    flex-direction: row;
`;

export const Item = styled.a`
    display: flex;
    padding-right: 10px;
`;

export const Icon = styled.img`
    width: 40px;
    height: 40px;
    margin-right: 8px;
`;

export const Labels = styled.div`
    border-right: 2px solid #eaeaea;
    padding-right: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    color: #333;
`;

export const Title = styled.p`
    margin-bottom: 5px;
`;

export const SecondaryTitle = styled.p`
    color: rgba(0, 0, 0, 0.5);
    font-size: 12.5px;
`;
